// How long the floating weapon icon (Game.js's _drawWeaponIcons) flashes/
// recoils after a fire — shared so the visual and the timer that drives it
// can't drift apart.
export const WEAPON_FIRE_FLASH_DURATION = 0.12;

/**
 * Base weapon class. Each weapon holds a fire timer and produces projectiles
 * via its `fire()` method when the timer elapses.
 */
export class Weapon {
  constructor(config) {
    this.config = config;
    this.timer = 0;
    this.level = 1;
    // Counts down from WEAPON_FIRE_FLASH_DURATION each time fire() runs —
    // purely a rendering hook, read by Game.js, not used by combat logic.
    this.fireFlash = 0;
  }

  get name() { return this.config.name; }

  /**
   * @param {number} dt
   * @param {{x:number,y:number}} origin  - weapon position (player)
   * @param {{x:number,y:number}} target  - where to aim (boss)
   * @param {import('./ProjectilePool.js').ProjectilePool} pool
   */
  update(dt, origin, target, pool) {
    this.fireFlash = Math.max(0, this.fireFlash - dt);
    this.timer -= dt;
    if (this.timer > 0) return;
    this.timer = this.config.fireRate;
    this.fire(origin, target, pool);
    this.fireFlash = WEAPON_FIRE_FLASH_DURATION;
  }

  /** Override in subclasses. Spawn projectiles via `pool.fire(config)`. */
  fire(origin, target, pool) {
    // subclass
  }

  levelUp(n = 1) {
    // Base weapons cap at 8; fused weapons (config/constants.js
    // FUSED_WEAPONS) declare their own shorter ladder via config.maxLevel.
    this.level = Math.min(this.level + n, this.config.maxLevel ?? 8);
  }
}
